import { SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import InfoCard from "../common/infoCard/infoCard";

export default function BookingInfoCard({
  children,
  sx = {},
}: {
  children: ReactNode | ReactNode[];
  sx?: SxProps<Theme>;
}) {
  return (
    <InfoCard
      sx={{
        overflow: "hidden",
        ...sx,
      }}
    >
      {children}
    </InfoCard>
  );
}
